export const textContent = [
  "This is a free tool for Toyhou.se that let's you pick raffle winners efficiently!",
  "Simply select the rules, and load your character!",
  "You can then adjust your participants in the tab on the top left!",
];
